var map = {
	"./10_nuts.png": 2480,
	"./1drink_12beer.png": 2481,
	"./1serving_8ounces.png": 2482,
	"./1serving_8ounces2.png": 2483,
	"./1serving_8ounces3.png": 2484,
	"./1serving_8ounces4.png": 2485,
	"./1serving_8ounces5.png": 2486,
	"./8ounces_1glass.png": 2487,
	"./can_1.png": 2488,
	"./can_2.png": 2489,
	"./can_3.png": 2490,
	"./cup.png": 2491,
	"./dried_serving_1/4cup.png": 2492,
	"./dried_serving_1:4cup.png": 2493,
	"./fresh_serving_1cup.png": 2494,
	"./glass_1.png": 2495,
	"./glass_2.png": 2496,
	"./golfball.png": 2497,
	"./halfthumb.png": 2498,
	"./hand_1.png": 2499,
	"./hand_2.png": 2500,
	"./hand_3.png": 2501,
	"./hand_4.png": 2502,
	"./hand_5.png": 2503,
	"./how.png": 872,
	"./serving_1/2cup.png": 2504,
	"./serving_1:2cup.png": 2505,
	"./serving_1tbsp.png": 2506,
	"./serving_3/4ounces.png": 2507,
	"./serving_3:4ounces.png": 2508,
	"./thumbx2.png": 2509,
	"./usda.png": 2510,
	"./vegetables_1cup.png": 2511,
	"./what.png": 870,
	"./wholethumb.png": 2512,
	"./why.png": 871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2479;